import flagsmith from "flagsmith";
import { ITraits } from "flagsmith/types";
import { ApplicationConfiguration } from "../types";

export async function initializeFeatureFlagProvider(
    applicationConfig: ApplicationConfiguration,
    identity: string,
    traits?: ITraits<string>,
) {
    const commonConfiguration = {
        cacheFlags: true,
        cacheOptions: {
            skipAPI: true,
        },
        environmentID: applicationConfig?.featureFlag?.key,
        identity,
        traits,
    };
    try {
        await flagsmith.init({
            ...commonConfiguration,
            api: applicationConfig?.featureFlag?.api,
            cacheOptions: {
                ...commonConfiguration.cacheOptions,
                ttl: 2 * 60 * 1000,
            },
        });
    } catch {
        await flagsmith.init({
            ...commonConfiguration,
            cacheOptions: {
                ...commonConfiguration.cacheOptions,
                ttl: 5 * 60 * 1000,
            },
        });
    }
}
